import moment from 'moment';

export function getModifiedFieldsOnly<T extends Record<string, any>>(
    updated: T,
    original: T,
    options?: {
        compareDates?: boolean;
        dateFormat?: string;
    }
): Partial<T> {
    const modified: Partial<T> = {};
    const { compareDates = true, dateFormat = 'YYYY-MM-DD' } = options || {};

    for (const key in updated) {
        const originalValue = original[key];
        const updatedValue = updated[key];

        const isDate =
            compareDates &&
            (moment.isMoment(originalValue) || moment.isDate(originalValue)) &&
            (moment.isMoment(updatedValue) || moment.isDate(updatedValue));

        if (isDate) {
            const formattedOrig = moment(originalValue).format(dateFormat);
            const formattedUpdated = moment(updatedValue).format(dateFormat);
            if (formattedOrig !== formattedUpdated) {
                modified[key] = updatedValue;
            }
        } else if (originalValue !== updatedValue) {
            modified[key] = updatedValue;
        }
    }

    return modified;
}
